export class IntituleLibreGroup {

  public intituleLibreLibelle: string;
  public intituleLibre: string;

  constructor() {
    this.intituleLibreLibelle = '';
    this.intituleLibre = '';
  }
}
